(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const CsvParser = {
        parse: function (file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = function (e) {
                    try {
                        const text = e.target.result;
                        const lines = text.split(/\r\n|\n/).map(l => l.trim()).filter(l => l.length > 0);
                        const tickersToAdd = [];

                        if (lines.length === 0) {
                            resolve([]);
                            return;
                        }

                        let headerIndex = -1;
                        let columnMap = {
                            ticker: -1,
                            quantity: -1,
                            totalCost: -1,
                            perShare: -1
                        };

                        const possibleTickerHeaders = ['SYMBOL', 'TICKER', 'STOCK', 'COMPANY', 'SYM', 'STOCK SYMBOL', 'TKR', 'COMPANY NAME'];
                        const possibleQtyHeaders = ['QUANTITY', 'QTY', 'SHARES', 'UNITS', 'COUNT', 'NUMBER OF SHARES', '# OF SHARES'];
                        const possibleTotalCostHeaders = ['COST BASIS', 'TOTAL COST', 'ADJUSTED COST', 'COST BASIS TOTAL', 'TOTAL COST BASIS', 'COST'];
                        const possiblePerShareHeaders = ['COST PER SHARE', 'COST PER SHR', 'CPS', 'SHARE COST', 'PRICE PAID', 'UNIT COST', 'AVG PRICE', 'AVG COST', 'PRICE'];

                        let maxScore = -1;

                        const splitCSVLine = (line) => {
                            const result = [];
                            let start = 0;
                            let inQuotes = false;
                            for (let i = 0; i < line.length; i++) {
                                if (line[i] === '"') {
                                    inQuotes = !inQuotes;
                                } else if (line[i] === ',' && !inQuotes) {
                                    result.push(line.substring(start, i).trim());
                                    start = i + 1;
                                }
                            }
                            result.push(line.substring(start).trim());
                            return result.map(s => s.replace(/^"|"$/g, '').trim());
                        };

                        for (let i = 0; i < Math.min(lines.length, 20); i++) {
                            const row = splitCSVLine(lines[i].toUpperCase());
                            let score = 0;
                            let tIndex = -1, qIndex = -1, tcIndex = -1, psIndex = -1;
                            for (let j = 0; j < row.length; j++) {
                                const cell = row[j];
                                if (possibleTickerHeaders.some(h => cell === h || cell === h + 'S' || cell.startsWith(h + ' ') || (cell.includes(h) && cell.length < h.length + 5))) {
                                    tIndex = j;
                                    score += 10;
                                    break;
                                }
                            }

                            if (tIndex !== -1) {
                                for (let j = 0; j < row.length; j++) {
                                    if (j === tIndex) continue;
                                    const cell = row[j];
                                    if (possibleQtyHeaders.some(h => {
                                        if (h === 'COUNT' && cell.includes('ACCOUNT')) return false;
                                        return cell === h || cell.includes(h) || cell.includes('(' + h + ')');
                                    })) {
                                        qIndex = j;
                                        score += 5;
                                        break;
                                    }
                                }

                                for (let j = 0; j < row.length; j++) {
                                    if (j === tIndex || j === qIndex) continue;
                                    const cell = row[j];
                                    if (possiblePerShareHeaders.some(h => cell === h || cell.includes(h))) {
                                        psIndex = j;
                                        score += 5;
                                        break;
                                    }
                                }

                                for (let j = 0; j < row.length; j++) {
                                    if (j === tIndex || j === qIndex || j === psIndex) continue;
                                    const cell = row[j];
                                    if (possibleTotalCostHeaders.some(h => cell === h || cell === h + ' ' || cell.includes(h))) {
                                        tcIndex = j;
                                        score += 5;
                                        break;
                                    }
                                }

                                if (score > maxScore) {
                                    maxScore = score;
                                    headerIndex = i;
                                    columnMap = { ticker: tIndex, quantity: qIndex, totalCost: tcIndex, perShare: psIndex };
                                }
                            }
                        }

                        if (headerIndex === -1 && lines.length > 0) {
                            const firstRow = splitCSVLine(lines[0]);
                            if (firstRow.length >= 3) {
                                headerIndex = -1;
                                columnMap = { ticker: 0, quantity: 1, totalCost: -1, perShare: 2 };
                            }
                        }

                        const startIndex = headerIndex + 1;

                        for (let i = startIndex; i < lines.length; i++) {
                            const row = splitCSVLine(lines[i]);
                            if (row[0] && row[0].toUpperCase().includes('TOTAL')) continue;
                            if (row.length === 0) continue;

                            if (columnMap.ticker !== -1 && row[columnMap.ticker]) {
                                let ticker = row[columnMap.ticker].toUpperCase().trim();

                                ticker = ticker.replace(/\*/g, '');

                                if (ticker.includes(' ')) {
                                    ticker = ticker.split(' ')[0];
                                }

                                if (!/^[A-Z0-9.-]+$/.test(ticker)) continue;
                                if (ticker === 'CASH' || ticker === 'TOTAL') continue;

                                let qty = 0;
                                let price = 0;

                                if (columnMap.quantity !== -1 && row[columnMap.quantity]) {
                                    const rawQ = row[columnMap.quantity];
                                    const qStr = rawQ.replace(/[^0-9.-]/g, '');
                                    qty = parseFloat(qStr) || 0;
                                }

                                let foundPrice = false;

                                if (columnMap.totalCost !== -1 && row[columnMap.totalCost]) {
                                    const rawTC = row[columnMap.totalCost];
                                    const tcStr = rawTC.replace(/[^0-9.-]/g, '');
                                    const totalCost = parseFloat(tcStr);

                                    if (!isNaN(totalCost)) {
                                        price = totalCost;
                                        foundPrice = true;
                                    }
                                }

                                if (!foundPrice && columnMap.perShare !== -1 && row[columnMap.perShare]) {
                                    const rawPS = row[columnMap.perShare];
                                    const psStr = rawPS.replace(/[^0-9.-]/g, '');
                                    const perShare = parseFloat(psStr);

                                    if (!isNaN(perShare)) {
                                        price = perShare * qty;
                                        foundPrice = true;
                                    }
                                }

                                tickersToAdd.push({ ticker, quantity: qty, price: price });
                            }
                        }

                        resolve(tickersToAdd);
                    } catch (err) {
                        reject(err);
                    }
                };
                reader.onerror = function (err) {
                    reject(err);
                };
                reader.readAsText(file);
            });
        },

        validateImport: async function(tickersToAdd, currentCount, isPremium, MAX_ITEMS_FREE) {
            let limitReached = false;
            let validTickers = [];
            let invalidTickerNames = [];

            if (!tickersToAdd || tickersToAdd.length === 0) {
                return { validTickers, invalidTickerNames, limitReached };
            }

            const syntacticallyValid = tickersToAdd.filter(t => /^[A-Z0-9.-]+$/.test(t.ticker));

            if (!isPremium && (currentCount + syntacticallyValid.length) > MAX_ITEMS_FREE) {
                limitReached = true;
                return { validTickers, invalidTickerNames, limitReached };
            }

            if (syntacticallyValid.length > 0) {
                await Promise.all(syntacticallyValid.map(async (item) => {
                    if (window.WatchlistAPIManager && window.WatchlistAPIManager.instance && window.WatchlistAPIManager.instance.validateTicker) {
                        const isValid = await window.WatchlistAPIManager.instance.validateTicker(item.ticker);
                        if (isValid) {
                            validTickers.push(item);
                        } else {
                            invalidTickerNames.push(item.ticker);
                        }
                    } else {
                        validTickers.push(item);
                    }
                }));
            }

            return { validTickers, invalidTickerNames, limitReached };
        }
    };

    window.WatchlistApp.CsvParser = CsvParser;
})();
